import React, { FC } from 'react';

import Box from '@mui/material/Box';
import { Options, useOption } from 'lib';

import { PaymentStatus } from '__generated__/PaymentStatus_payment.graphql';

export const optionsConfig: Options<PaymentStatus> = {
  PAID: {
    label: 'Apmokėta',
    color: 'success',
  },
  INFO: {
    label: 'Informacija',
    color: 'info',
  },
  PENDING: {
    label: 'Laukiama apmokėjimo',
    color: 'warning',
  },
  CANCEL: {
    label: 'Atšaukta',
    color: 'error',
  },
};

type Props = {
  status: PaymentStatus;
};

const PaymentStatusText: FC<Props> = ({ status }) => {
  const { color, label } = useOption(status, optionsConfig);

  return <Box color={color}>{label}</Box>;
};

export default PaymentStatusText;
